/**
 * Rollup-mode note counts for listing screens whose rows are Subscribers or
 * Schemes. Returns the full count of notes touching each subscriber/scheme via
 * the denormalised rollup columns — the same view NotesPanel shows on the
 * audit-trail Notes tab. Listing badges that count anchored notes only
 * undercount because most notes are posted against sub-artifacts (extraction
 * rights, meters, AAs) and rolled up via the denormalised FK.
 */
import { useQuery } from "@tanstack/react-query";

import { getNoteRollupCounts } from "@services/notes";

export const useNoteRollupCounts = (
  rollupBy: "subscriber" | "scheme",
  ids: string[],
) => {
  return useQuery(
    ["noteRollupCounts", rollupBy, ids.slice().sort().join(",")],
    () => getNoteRollupCounts(rollupBy, ids),
    {
      enabled: ids.length > 0,
      keepPreviousData: true,
    },
  );
};
